import classNames from 'classnames';
import * as React from 'react';

type Props = {
  rank: number;
  index: number;
  selectedPage: number;
  open: boolean;
};

type State = {
  zIndex: number;
};

export class Page extends React.PureComponent<Props, State> {
  public constructor(props: Props) {
    super(props);

    this.state = {
      zIndex: props.rank,
    };
  }

  private getTransform() {
    const { rank, open } = this.props;

    if (open) {
      return `translate3d(0, 75%, -${350 - Math.max(rank, 1) * 50}px)`;
    }

    if (rank < 3) {
      return 'translate3d(0, 100%, 0)';
    }

    return 'translate3d(0, 0, 0)';
  }

  public render() {
    const { rank, index, selectedPage } = this.props;
    const inactive = selectedPage !== index;

    return (
      <div
        className={classNames('page', {
          'page--inactive': inactive,
        })}
        style={{
          zIndex: this.state.zIndex,
          transform: this.getTransform(),
          opacity: Math.min(rank, 1),
        }}
        onTransitionEnd={() => { this.setState({ zIndex: rank }); }}
      >
        {this.props.children}
      </div>
    );
  }
}
